import { render, staticRenderFns } from "./PartnerSettingsScreen.vue?vue&type=template&id=660eb367&scoped=true&"
import script from "./PartnerSettingsScreen.vue?vue&type=script&lang=js&"
export * from "./PartnerSettingsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660eb367",
  null
  
)

export default component.exports